/*
 * This unpublished material is proprietary to Vaticle.
 * All rights reserved. The methods and
 * techniques described herein are considered trade secrets
 * and/or confidential. Reproduction or distribution, in whole
 * or in part, is forbidden except by express written permission
 * of Vaticle.
 */

import { Component } from "@angular/core";
import { Router, RouterLink } from "@angular/router";
import { ButtonComponent } from "typedb-cloud-framework";
import { MfaSetupComponent } from "../../user/mfa-setup/mfa-setup.component";
import { IdentityAuthService } from "../../../service/authentication/identity-auth.service";

@Component({
    selector: "tp-mfa-setup-page",
    templateUrl: "mfa-setup-page.component.html",
    imports: [MfaSetupComponent, ButtonComponent, RouterLink]
})
export class MfaSetupPageComponent {

    settingUpMfa = false;

    constructor(private router: Router, private auth: IdentityAuthService) {
        if (this.auth.currentUserMultiFactors.length > 0) this.router.navigate(["/setup"]);
    }

    nextPage() {
        this.router.navigate(["/setup"]);
    }
}
